export const TITLE = {
  SBOTD: 'Special Buy of the Day',
  SBOTW: 'Pro Special Buy of The Week',
  DAILY_DEALS: 'Daily Deals'
};

export const FEATURE_SWITCH_KEYS = {
  isDailyDealsEnabled: 'fs:pricing--isDailyDealsEnabled',
};